export const checkDifferentFilterAndFormValues = (formValues: any, filter: any): boolean => {
    return (
        JSON.stringify(
            { ...formValues, options: undefined },
            Object.keys({ ...formValues, options: undefined }).sort(),
        ) !== JSON.stringify({ ...filter, options: undefined }, Object.keys({ ...filter, options: undefined }).sort())
    );
};
